import { Menu, menuTemplate as template } from '@microsoft/fast-foundation';
import { NavigationDrawerComponent } from './NavigationDrawer';
import styles from './NavigationDrawer.styles.scss';
import { withStylePrefix } from '../common/withStylePrefix';
export const navigationDrawerDefinition = {
    baseName: 'navigation-drawer',
    baseClass: Menu,
    template: template,
    styles: withStylePrefix(styles),
};
export const chameleonNavigationDrawer = NavigationDrawerComponent.compose(navigationDrawerDefinition);
